import {
  fetchWithToken,
  getEnv,
  getRegion,
} from '@adsk/acs-sc-web-platform-api';

import { envConfig } from './consts';
import {
  RawAsset,
  AssetsResponse,
  AssetsPaginatedResponse,
  Category,
  Status,
  CategoryMetadata,
} from './types';

type Filters = {
  limit: number;
  'filter[searchText]'?: string;
};

const buildQueryString = (params: Filters): string =>
  Object.entries(params)
    .reduce((searchParams, [key, value]) => {
      if (value !== undefined) {
        searchParams.append(
          key,
          typeof value === 'string' ? value : value.toString(),
        );
      }
      return searchParams;
    }, new URLSearchParams())
    .toString();

const getBaseUrl = (): string => envConfig[getRegion()][getEnv()].assetsBackend;

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export default {
  queryAssets: async (
    projectId: string,
    nextUrl: string | undefined,
    filters: Filters,
  ) => {
    const queryString = buildQueryString(filters);
    return await fetchWithToken<AssetsPaginatedResponse<RawAsset[]>>(
      nextUrl ||
        `${getBaseUrl()}/${projectId}/assets${
          queryString ? `?${queryString}` : ''
        }`,
      { headers },
    );
  },
  batchGetAssets: async (projectId: string, ids: RawAsset['id'][]) =>
    (
      await fetchWithToken<AssetsResponse<RawAsset[]>>(
        `${getBaseUrl()}/${projectId}/assets:batch-get`,
        {
          headers,
          method: 'POST',
          body: JSON.stringify({ ids }),
        },
      )
    ).results,
  batchGetCategories: async (
    projectId: string,
    ids: Category['id'][],
  ): Promise<Category[]> =>
    (
      await fetchWithToken<AssetsResponse<Category[]>>(
        `${getBaseUrl()}/${projectId}/categories:batch-get`,
        {
          headers,
          method: 'POST',
          body: JSON.stringify({ ids }),
        },
      )
    ).results,
  batchGetCategoryMetadata: async (
    projectId: string,
    ids: Category['id'][],
  ): Promise<CategoryMetadata[]> =>
    (
      await fetchWithToken<AssetsResponse<CategoryMetadata[]>>(
        `${getBaseUrl()}/${projectId}/category-metadata:batch-get`,
        {
          headers,
          method: 'POST',
          body: JSON.stringify({ ids }),
        },
      )
    ).results,
  batchGetStatuses: async (
    projectId: string,
    ids: Status['id'][],
  ): Promise<Status[]> =>
    (
      await fetchWithToken<AssetsResponse<Status[]>>(
        `${getBaseUrl()}/${projectId}/asset-statuses:batch-get?includeDeleted=true`,
        {
          headers,
          method: 'POST',
          body: JSON.stringify({ ids }),
        },
      )
    ).results,
};
